import React from "react";
import "./style.scss";

const Index = () => {
  return (
    <div className="blog-header-container">
      <div className="inner-blog-header-container">
        <small className="header-small">Blogg</small>
        <h5 className="header-title">Siste nytt om Leadfind</h5>
        <p className="header-description">
          Les om oppdateringer rundt tjenesten og et utvalg av gjesteinnlegg.
        </p>
      </div>
    </div>
  );
};

export default Index;
